import { render, staticRenderFns } from "./TipoContratoForm.vue?vue&type=template&id=4f3aaf6b"
import script from "./TipoContratoForm.vue?vue&type=script&lang=js"
export * from "./TipoContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports